<template>
<div class="chapter">
<div class="inner_page">
<a id="page_xv">
<h2 class="fm_title">Abbreviations</h2>
<table>
<tbody><tr>
<td class="td1">AA</td>
<td class="td2">Anti-Aircraft</td>
</tr>
<tr>
<td class="td1">ADC</td>
<td class="td2">Aide-de-Camp</td>
</tr>
<tr>
<td class="td1">ADS</td>
<td class="td2">Advanced Dressing Station</td>
</tr>
<tr>
<td class="td1">AFC</td>
<td class="td2">Australian Flying Corps</td>
</tr>
<tr>
<td class="td1">AIF</td>
<td class="td2">Australian Imperial Force</td>
</tr>
<tr>
<td class="td1">AMF(L)</td>
<td class="td2">ACE (Allied Command Europe) Mobile Force (Land)</td>
</tr>
<tr>
<td class="td1">AMICE</td>
<td class="td2">Associate Member of the Institution of Civil Engineers</td>
</tr>
<tr>
<td class="td1">ASC</td>
<td class="td2">Army Service Corps</td>
</tr>
<tr>
<td class="td1">ATS</td>
<td class="td2">Auxiliary Territorial Service</td>
</tr>
<tr>
<td class="td1">AWOL</td>
<td class="td2">Absent without leave</td>
</tr>
<tr>
<td class="td1">Att’d</td>
<td class="td2">Attached</td>
</tr>
<tr>
<td class="td1">BA</td>
<td class="td2">Bachelor of Arts</td>
</tr>
<tr>
<td class="td1">BCh or ChB</td>
<td class="td2">Bachelor of Surgery</td>
</tr>
<tr>
<td class="td1">BEF</td>
<td class="td2">British Expeditionary Force</td>
</tr>
<tr>
<td class="td1">BMA</td>
<td class="td2">British Medical Association</td>
</tr>
<tr>
<td class="td1">Brig-Gen</td>
<td class="td2">Brigadier-General</td>
</tr>
<tr>
<td class="td1">BSc</td>
<td class="td2">Bachelor of Science</td>
</tr>
<tr>
<td class="td1">Bty</td>
<td class="td2">Battery (artillery unit of 4–8 guns)</td>
</tr>
<tr>
<td class="td1">Capt</td>
<td class="td2">Captain</td>
</tr>
<tr>
<td class="td1">CB</td>
<td class="td2">Companion of the Order of the Bath</td>
</tr>
<tr>
<td class="td1">CB</td>
<td class="td2">Confined to Barracks</td>
</tr>
<tr>
<td class="td1">CBE</td>
<td class="td2">Commander of the Order of the British Empire</td>
</tr>
<tr>
<td class="td1">CCF</td>
<td class="td2">Combined Cadet Force</td>
</tr>
<tr>
<td class="td1">CCS</td>
<td class="td2">Casualty Clearing Station</td>
</tr>
<tr>
<td class="td1">CEF</td>
<td class="td2">Canadian Expeditionary Force</td>
</tr>
<tr>
<td class="td1">CIE</td>
<td class="td2">Companion of the Order of the Indian Empire</td>
</tr>
<tr>
<td class="td1">C-in-C</td>
<td class="td2">Commander-in-Chief</td>
</tr>
<tr>
<td class="td1">CMG</td>
<td class="td2">Companion of the Order of St Michael &amp; St George</td>
</tr>
<tr>
<td class="td1">CO</td>
<td class="td2">Commanding Officer</td>
</tr>
<tr>
<td class="td1">Col</td>
<td class="td2">Colonel</td>
</tr>
<tr>
<td class="td1">Cpl</td>
<td class="td2">Corporal</td>
</tr>
<tr>
<td class="td1">CQMS</td>
<td class="td2">Company Quartermaster Sergeant</td>
</tr>
<tr>
<td class="td1">CRA</td>
<td class="td2">Commander Royal Artillery</td>
</tr>
<tr>
<td class="td1">CRE</td>
<td class="td2">Commander Royal Engineers</td>
</tr>
<tr>
<td class="td1"><a id="page_xvi">CSgt</a></td>
<td class="td2">Colour Sergeant</td>
</tr>
<tr>
<td class="td1">CSEF</td>
<td class="td2">Canadian Siberian Expeditionary Force</td>
</tr>
<tr>
<td class="td1">CSI</td>
<td class="td2">Companion of the Order of the Star of India</td>
</tr>
<tr>
<td class="td1">CSM</td>
<td class="td2">Company Sergeant Major</td>
</tr>
<tr>
<td class="td1">CStJ</td>
<td class="td2">Commander of the Most Venerable Order of the Hospital of Saint John of Jerusalem</td>
</tr>
<tr>
<td class="td1">Cty</td>
<td class="td2">Cemetery</td>
</tr>
<tr>
<td class="td1">CVO</td>
<td class="td2">Commander of the Royal Victorian Order</td>
</tr>
<tr>
<td class="td1">CWGC</td>
<td class="td2">Commonwealth War Graves Commission</td>
</tr>
<tr>
<td class="td1">DAAG</td>
<td class="td2">Deputy Assistant Adjutant General</td>
</tr>
<tr>
<td class="td1">DBE</td>
<td class="td2">Dame Commander of the Order of the British Empire</td>
</tr>
<tr>
<td class="td1">DCL</td>
<td class="td2">Doctor of Civil Law</td>
</tr>
<tr>
<td class="td1">DCLI</td>
<td class="td2">Duke of Cornwall’s Light Infantry</td>
</tr>
<tr>
<td class="td1">DCM</td>
<td class="td2">Distinguished Conduct Medal</td>
</tr>
<tr>
<td class="td1">DCO</td>
<td class="td2">Draft Conducting Officer</td>
</tr>
<tr>
<td class="td1">DFC</td>
<td class="td2">Distinguished Flying Cross</td>
</tr>
<tr>
<td class="td1">DL</td>
<td class="td2">Deputy Lieutenant</td>
</tr>
<tr>
<td class="td1">DLI</td>
<td class="td2">Durham Light Infantry</td>
</tr>
<tr>
<td class="td1">DSC</td>
<td class="td2">Distinguished Service Cross</td>
</tr>
<tr>
<td class="td1">DSO</td>
<td class="td2">Distinguished Service Order</td>
</tr>
<tr>
<td class="td1">Dvr</td>
<td class="td2">Driver</td>
</tr>
<tr>
<td class="td1">ENT</td>
<td class="td2">Ear, Nose and Throat</td>
</tr>
<tr>
<td class="td1">FInstCE</td>
<td class="td2">Fellow of the Institution of Civil Engineers</td>
</tr>
<tr>
<td class="td1">FM</td>
<td class="td2">Field Marshal</td>
</tr>
<tr>
<td class="td1">FRAS</td>
<td class="td2">Fellow of the Royal Astronomical Society</td>
</tr>
<tr>
<td class="td1">FRCP</td>
<td class="td2">Fellow of the Royal College of Physicians</td>
</tr>
<tr>
<td class="td1">FRCS</td>
<td class="td2">Fellow of the Royal College of Surgeons</td>
</tr>
<tr>
<td class="td1">FRCSE</td>
<td class="td2">Fellow of the Royal College of Surgeons of England</td>
</tr>
<tr>
<td class="td1">FRS</td>
<td class="td2">Fellow of the Royal Society</td>
</tr>
<tr>
<td class="td1">FRSM</td>
<td class="td2">Fellow of the Royal Society of Medicine (also FRSocMed)</td>
</tr>
<tr>
<td class="td1">FSA</td>
<td class="td2">Fellow of the Society of Actuaries</td>
</tr>
<tr>
<td class="td1">GC</td>
<td class="td2">George Cross</td>
</tr>
<tr>
<td class="td1">GCB</td>
<td class="td2">Knight Grand Cross of the Order of the Bath</td>
</tr>
<tr>
<td class="td1">GCMG</td>
<td class="td2">Knight Grand Cross of the Order of St Michael &amp; St George</td>
</tr>
<tr>
<td class="td1">Gen</td>
<td class="td2">General</td>
</tr>
<tr>
<td class="td1">GOC</td>
<td class="td2">General Officer Commanding</td>
</tr>
<tr>
<td class="td1">GOC-in-C</td>
<td class="td2">General Officer Commanding in Chief</td>
</tr>
<tr>
<td class="td1">GSO1, 2 or 3</td>
<td class="td2">General Staff Officer Grade 1 (Lt Col), 2 (Maj) or 3 (Capt)</td>
</tr>
<tr>
<td class="td1">HAC</td>
<td class="td2">Honourable Artillery Company</td>
</tr>
<tr>
<td class="td1">HE</td>
<td class="td2">High Explosive</td>
</tr>
<tr>
<td class="td1">HLI</td>
<td class="td2">Highland Light Infantry</td>
</tr>
<tr>
<td class="td1">HMHS</td>
<td class="td2">Her/His Majesty’s Hospital Ship</td>
</tr>
<tr>
<td class="td1"><a id="page_xvii">HMS</a></td>
<td class="td2">Her/His Majesty’s Ship</td>
</tr>
<tr>
<td class="td1">HMT</td>
<td class="td2">Her/His Majesty’s Transport/Troopship/Hired Military Transport</td>
</tr>
<tr>
<td class="td1">HMNZT</td>
<td class="td2">Her/His Majesty’s New Zealand Transport/Troopship</td>
</tr>
<tr>
<td class="td1">HRH</td>
<td class="td2">His/Her Royal Highness</td>
</tr>
<tr>
<td class="td1">HS</td>
<td class="td2">Hospital Ship</td>
</tr>
<tr>
<td class="td1">JP</td>
<td class="td2">Justice of the Peace</td>
</tr>
<tr>
<td class="td1">KBE</td>
<td class="td2">Knight Commander of the Most Excellent Order of the British Empire</td>
</tr>
<tr>
<td class="td1">KCB</td>
<td class="td2">Knight Commander of the Order of the Bath</td>
</tr>
<tr>
<td class="td1">KCIE</td>
<td class="td2">Knight Commander of the Order of the Indian Empire</td>
</tr>
<tr>
<td class="td1">KCMG</td>
<td class="td2">Knight Commander of St Michael and St George</td>
</tr>
<tr>
<td class="td1">KCVO</td>
<td class="td2">Knight Commander of the Royal Victorian Order</td>
</tr>
<tr>
<td class="td1">KGStJ</td>
<td class="td2">Knight of Grace of the Most Venerable Order of the Hospital of Saint John of Jerusalem</td>
</tr>
<tr>
<td class="td1">Kia</td>
<td class="td2">Killed in action</td>
</tr>
<tr>
<td class="td1">KJStJ</td>
<td class="td2">Knight of Justice of the Most Venerable Order of the Hospital of Saint John of Jerusalem</td>
</tr>
<tr>
<td class="td1">Kms</td>
<td class="td2">Kilometres</td>
</tr>
<tr>
<td class="td1">KOSB</td>
<td class="td2">King’s Own Scottish Borderers</td>
</tr>
<tr>
<td class="td1">KOYLI</td>
<td class="td2">King’s Own Yorkshire Light Infantry</td>
</tr>
<tr>
<td class="td1">KRRC</td>
<td class="td2">King’s Royal Rifle Corps</td>
</tr>
<tr>
<td class="td1">KSLI</td>
<td class="td2">King’s Shropshire Light Infantry</td>
</tr>
<tr>
<td class="td1">LCpl</td>
<td class="td2">Lance Corporal</td>
</tr>
<tr>
<td class="td1">LG</td>
<td class="td2">London Gazette</td>
</tr>
<tr>
<td class="td1">LLB</td>
<td class="td2">Legum Baccalaureus (Bachelor of Laws)</td>
</tr>
<tr>
<td class="td1">LLD</td>
<td class="td2">Legum Doctor (Doctor of Law)</td>
</tr>
<tr>
<td class="td1">Lt</td>
<td class="td2">Lieutenant</td>
</tr>
<tr>
<td class="td1">Lt</td>
<td class="td2">Col Lieutenant Colonel</td>
</tr>
<tr>
<td class="td1">Lt</td>
<td class="td2">Gen Lieutenant General</td>
</tr>
<tr>
<td class="td1">LTh</td>
<td class="td2">Licentiate in Theology</td>
</tr>
<tr>
<td class="td1">Maj</td>
<td class="td2">Major</td>
</tr>
<tr>
<td class="td1">Maj</td>
<td class="td2">Gen Major General</td>
</tr>
<tr>
<td class="td1">MA</td>
<td class="td2">Master of Arts</td>
</tr>
<tr>
<td class="td1">MB</td>
<td class="td2">Bachelor of Medicine</td>
</tr>
<tr>
<td class="td1">MB BCh</td>
<td class="td2">Bachelor of Medicine, Bachelor of Surgery (also MBChB MBBS MBBChir)</td>
</tr>
<tr>
<td class="td1">MBE</td>
<td class="td2">Member of the Order of the British Empire</td>
</tr>
<tr>
<td class="td1">MC</td>
<td class="td2">Military Cross</td>
</tr>
<tr>
<td class="td1">MCh</td>
<td class="td2">Master of Surgery</td>
</tr>
<tr>
<td class="td1">MD</td>
<td class="td2">Medical Doctor</td>
</tr>
<tr>
<td class="td1">MGC</td>
<td class="td2">Machine Gun Corps</td>
</tr>
<tr>
<td class="td1">MID</td>
<td class="td2">Mentioned in Despatches</td>
</tr>
<tr>
<td class="td1"><a id="page_xviii">M.Inst.CE</a></td>
<td class="td2">Member of the Institute of Civil Engineers (MIE)</td>
</tr>
<tr>
<td class="td1">MM</td>
<td class="td2">Military Medal</td>
</tr>
<tr>
<td class="td1">MO</td>
<td class="td2">Medical Officer</td>
</tr>
<tr>
<td class="td1">MOD</td>
<td class="td2">Ministry of Defence</td>
</tr>
<tr>
<td class="td1">MP</td>
<td class="td2">Member of Parliament</td>
</tr>
<tr>
<td class="td1">MRCP</td>
<td class="td2">Member of the Royal College of Physicians</td>
</tr>
<tr>
<td class="td1">MRCS</td>
<td class="td2">Member of the Royal College of Surgeons</td>
</tr>
<tr>
<td class="td1">MSM</td>
<td class="td2">Meritorious Service Medal</td>
</tr>
<tr>
<td class="td1">MT</td>
<td class="td2">Motor Transport</td>
</tr>
<tr>
<td class="td1">MVO</td>
<td class="td2">Member of the Royal Victorian Order</td>
</tr>
<tr>
<td class="td1">NSW</td>
<td class="td2">New South Wales</td>
</tr>
<tr>
<td class="td1">NZEF</td>
<td class="td2">New Zealand Expeditionary Force</td>
</tr>
<tr>
<td class="td1">OBE</td>
<td class="td2">Officer of the Order of the British Empire</td>
</tr>
<tr>
<td class="td1">OC</td>
<td class="td2">Officer Commanding</td>
</tr>
<tr>
<td class="td1">OP</td>
<td class="td2">Observation Post</td>
</tr>
<tr>
<td class="td1">OStJ</td>
<td class="td2">Officer of the Most Venerable Order of the Hospital of Saint John of Jerusalem</td>
</tr>
<tr>
<td class="td1">OTC</td>
<td class="td2">Officers’ Training Corps</td>
</tr>
<tr>
<td class="td1">PC</td>
<td class="td2">Police Constable</td>
</tr>
<tr>
<td class="td1">PoW</td>
<td class="td2">Prisoner of War</td>
</tr>
<tr>
<td class="td1">PPCLI</td>
<td class="td2">Princess Patricia’s Canadian Light Infantry</td>
</tr>
<tr>
<td class="td1">PPS</td>
<td class="td2">Parliamentary Private Secretary</td>
</tr>
<tr>
<td class="td1">Pte</td>
<td class="td2">Private</td>
</tr>
<tr>
<td class="td1">QAINSR</td>
<td class="td2">Queen Alexandra’s Imperial Nursing Service Reserve</td>
</tr>
<tr>
<td class="td1">QC</td>
<td class="td2">Queen’s Counsel</td>
</tr>
<tr>
<td class="td1">RA</td>
<td class="td2">Royal Artillery</td>
</tr>
<tr>
<td class="td1">RAAF</td>
<td class="td2">Royal Auxiliary Air Force/Royal Australian Air Force</td>
</tr>
<tr>
<td class="td1">RAC</td>
<td class="td2">Royal Agricultural College</td>
</tr>
<tr>
<td class="td1">RAC</td>
<td class="td2">Royal Armoured Corps</td>
</tr>
<tr>
<td class="td1">RAF</td>
<td class="td2">Royal Air Force</td>
</tr>
<tr>
<td class="td1">RAFVR</td>
<td class="td2">Royal Air Force Volunteer Reserve</td>
</tr>
<tr>
<td class="td1">RAMC</td>
<td class="td2">Royal Army Medical Corps</td>
</tr>
<tr>
<td class="td1">RASC</td>
<td class="td2">Royal Army Service Corps</td>
</tr>
<tr>
<td class="td1">RCT</td>
<td class="td2">Royal Corps of Transport</td>
</tr>
<tr>
<td class="td1">RE</td>
<td class="td2">Royal Engineers</td>
</tr>
<tr>
<td class="td1">REME</td>
<td class="td2">Royal Electrical and Mechanical Engineers</td>
</tr>
<tr>
<td class="td1">RETC</td>
<td class="td2">Royal Engineers Training Centre</td>
</tr>
<tr>
<td class="td1">RFA</td>
<td class="td2">Royal Field Artillery</td>
</tr>
<tr>
<td class="td1">RFC</td>
<td class="td2">Royal Flying Corps</td>
</tr>
<tr>
<td class="td1">RGA</td>
<td class="td2">Royal Garrison Artillery</td>
</tr>
<tr>
<td class="td1">RHA</td>
<td class="td2">Royal Horse Artillery</td>
</tr>
<tr>
<td class="td1">RLC</td>
<td class="td2">Royal Logistic Corps</td>
</tr>
<tr>
<td class="td1"><a id="page_xix">RMO</a></td>
<td class="td2">Regimental Medical Officer</td>
</tr>
<tr>
<td class="td1">RMS</td>
<td class="td2">Royal Mail Ship/Steamer</td>
</tr>
<tr>
<td class="td1">RN</td>
<td class="td2">Royal Navy</td>
</tr>
<tr>
<td class="td1">RNR</td>
<td class="td2">Royal Naval Reserve</td>
</tr>
<tr>
<td class="td1">RSL</td>
<td class="td2">Returned and Services League</td>
</tr>
<tr>
<td class="td1">RSM</td>
<td class="td2">Regimental Sergeant Major</td>
</tr>
<tr>
<td class="td1">RSPCA</td>
<td class="td2">Royal Society for the Prevention of Cruelty to Animals</td>
</tr>
<tr>
<td class="td1">RTO</td>
<td class="td2">Railway Transport Officer</td>
</tr>
<tr>
<td class="td1">SAI</td>
<td class="td2">South African Infantry</td>
</tr>
<tr>
<td class="td1">Sgt</td>
<td class="td2">Sergeant</td>
</tr>
<tr>
<td class="td1">SMLE</td>
<td class="td2">Short Magazine Lee Enfield</td>
</tr>
<tr>
<td class="td1">SNCO</td>
<td class="td2">Senior non-commissioned officers</td>
</tr>
<tr>
<td class="td1">SOE</td>
<td class="td2">Special Operations Executive</td>
</tr>
<tr>
<td class="td1">Spr</td>
<td class="td2">Sapper</td>
</tr>
<tr>
<td class="td1">SS</td>
<td class="td2">Steam Ship</td>
</tr>
<tr>
<td class="td1">TA</td>
<td class="td2">Territorial Army</td>
</tr>
<tr>
<td class="td1">TD</td>
<td class="td2">Territorial Decoration</td>
</tr>
<tr>
<td class="td1">TF</td>
<td class="td2">Territorial Force</td>
</tr>
<tr>
<td class="td1">TMB</td>
<td class="td2">Trench Mortar Battery</td>
</tr>
<tr>
<td class="td1">Tr</td>
<td class="td2">Trench</td>
</tr>
<tr>
<td class="td1">VAD</td>
<td class="td2">Voluntary Aid Detachment</td>
</tr>
<tr>
<td class="td1">VD</td>
<td class="td2">Volunteer Decoration</td>
</tr>
<tr>
<td class="td1">VC</td>
<td class="td2">Victoria Cross</td>
</tr>
<tr>
<td class="td1">VIP</td>
<td class="td2">Very Important Person</td>
</tr>
<tr>
<td class="td1">WAAF</td>
<td class="td2">Women’s Auxiliary Air Force</td>
</tr>
<tr>
<td class="td1">WAAC</td>
<td class="td2">Women’s Auxiliary Army Corps</td>
</tr>
<tr>
<td class="td1">WG</td>
<td class="td2">Welsh Guards</td>
</tr>
<tr>
<td class="td1">WO1 or 2</td>
<td class="td2">Warrant Officer Class 1 or 2</td>
</tr>
<tr>
<td class="td1">YMCA</td>
<td class="td2">Young Men’s Christian Association</td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?18c9a654